const MandateTypes = {
  AssetManagement: 1,
}

export default MandateTypes
